import { render, staticRenderFns } from "./ChangePwdPanel.vue?vue&type=template&id=05fa8daf&scoped=true"
import script from "./ChangePwdPanel.vue?vue&type=script&lang=js"
export * from "./ChangePwdPanel.vue?vue&type=script&lang=js"
import style0 from "./ChangePwdPanel.vue?vue&type=style&index=0&id=05fa8daf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05fa8daf",
  null
  
)

export default component.exports